// Словарь части 5.2 «Исполнение и время»: «Задачи», таймер, записи времени, табель, проверка и подтверждение часов,
// «К выплате». Подключается в `ru.ts` поверх словаря производства.

/** Интерфейс исполнения и времени (ключи `projects.*`). */
export const ruProjectsWork = {
  notifications: {
    reviewTitle: 'Задача «{title}» на проверке',
    reviewBody: 'Проект «{project}»: примите задачу и подтвердите часы',
    acceptedTitle: 'Задача «{title}» принята',
    acceptedBody: 'Подтверждено {hours}',
    returnedTitle: 'Задача «{title}» возвращена',
    timerLongTitle: 'Таймер идёт {hours}',
    timerLongBody: 'Задача «{title}» — остановите таймер, если работа закончена',
    dueTomorrowTitle: 'Срок задачи «{title}» — завтра',
    stageAtRiskTitle: 'Этап «{stage}» под угрозой срыва',
    stageAtRiskBody: 'Проект «{project}»: посмотрите задачи этапа на Ганте',
  },
  payoutLine: '{task} — {project}',
  my: {
    title: 'Задачи',
    hint: 'Ваши открытые задачи во всех проектах — по срокам. Здесь же проверка задач ваших проектов и недельный табель',
    tabMine: 'Мои',
    tabReview: 'На проверке у меня',
    tabTime: 'Время',
    groups: {
      overdue: 'Просрочено',
      today: 'Сегодня',
      week: 'На неделе',
      later: 'Позже',
      waiting: 'Ждёт',
    },
    emptyTitle: 'Открытых задач нет',
    emptyText: 'Когда руководитель проекта назначит вам задачу, она появится здесь — по срокам',
    reviewEmptyTitle: 'Проверять нечего',
    reviewEmptyText: 'Задачи, которые исполнители отправят на проверку в ваших проектах, появятся здесь',
    startTimer: 'Запустить таймер: {title}',
    due: 'до {date}',
    noDue: 'Без срока',
    check: 'Проверить',
  },
  timer: {
    start: 'Запустить таймер',
    stop: 'Остановить таймер',
    openTask: 'Открыть задачу · {project}',
  },
  time: {
    title: 'Время',
    loggedOfPlan: '{logged} из {planned}',
    loggedOfPlanShort: '{logged} / {planned}',
    add: 'Внести время',
    runningBy: 'Таймер идёт: {names}',
    empty: 'Времени по задаче пока нет',
    emptyCanLog: 'Времени пока нет — запустите таймер или внесите часы вручную',
    showAll: 'Показать все записи ({count})',
    on: 'Дата',
    hours: 'Часы',
    hoursPlaceholder: '1,5',
    note: 'Заметка',
    notePlaceholder: 'Что сделано — по желанию',
    save: 'Внести',
    fromTimer: 'С таймера',
    confirmed: 'Часы подтверждены',
    remove: 'Удалить запись',
    toast: {
      stopped: 'Записано {hours}',
      removed: 'Запись на {hours} удалена',
    },
  },
  review: {
    title: 'Проверка',
    waitingLead: 'Задача на проверке у руководителя проекта',
    noTime: 'Времени по задаче не записано — принять можно и так',
    logged: 'записано {hours}',
    confirmFor: 'Подтвердить часы: {name}',
    timerRunning: 'Таймер идёт',
    reason: 'Причина поправки',
    reasonPlaceholder: 'Почему часы поправлены — увидит сотрудник',
    total: 'Итого к выплате: {amount}',
    stopTimersFirst: 'Пока на задаче идёт таймер, принять её нельзя — пусть исполнитель его остановит',
    comment: 'Что доработать',
    commentPlaceholder: 'Что доработать — комментарий уйдёт в обсуждение задачи',
    sendBack: 'Вернуть',
    return: 'Вернуть на доработку',
    accept: 'Принять и подтвердить часы',
    confirmedTitle: 'Подтверждённые часы',
    wasLogged: 'записано {hours}',
    acceptMenu: 'Готово — принять…',
    returnMenu: 'В работу — вернуть…',
    toast: {
      accepted: 'Задача «{title}» принята, часы подтверждены',
      returned: 'Задача «{title}» возвращена на доработку',
    },
  },
  kanban: {
    planned: 'План: {hours}',
    emptyColumn: 'Пусто',
    draggable: 'Задача, можно перетащить',
    dragInstructions: 'Пробел — взять задачу, стрелки — выбрать колонку, пробел — положить, Esc — отменить',
    announceStart: 'Задача «{title}» взята',
    announceOver: 'Задача «{title}» над колонкой «{status}»',
    announceDrop: 'Задача «{title}» в колонке «{status}»',
    announceCancel: 'Задача «{title}» осталась на месте',
    notAllowed: 'Из «{from}» в «{to}» так не перевести',
    hints: {
      queue: 'Задачи, к которым ещё не приступили. Исполнитель берёт задачу в работу сам',
      in_progress: 'Задачи, над которыми идёт работа: время пишется таймером или вручную',
      review:
        'Исполнитель закончил — руководитель проверяет, принимает и подтверждает часы или возвращает с комментарием',
      done: 'Принятые задачи: часы подтверждены и копятся сотруднику к выплате',
    },
  },
  projectTime: {
    people: 'По людям',
    tasks: 'По задачам',
    task: 'Задача',
    status: 'Статус',
    plan: 'План',
    fact: 'Факт',
    delta: 'Разница',
    who: 'Кто',
    left: 'в плане, ещё {hours}',
    over: '+{hours}',
    emptyTitle: 'Времени в проекте пока нет',
    emptyText:
      'Когда участники начнут писать время — таймером или вручную, — здесь будет план и факт по задачам и людям',
  },
  timesheet: {
    title: 'Табель',
    previous: 'Предыдущая неделя',
    next: 'Следующая неделя',
    thisWeek: 'Эта неделя',
    week: 'Неделя {from} — {to}',
    task: 'Задача',
    total: 'Итого',
    dayTotal: 'За день',
    weekTotal: 'За неделю',
    days: 'Дни недели',
    dayLabel: '{day}: {hours}',
    of: 'из {hours}',
    dayOff: 'выходной',
    cell: '{task}, {date}',
    locked: 'Часы подтверждены — правит руководитель',
    emptyTitle: 'На этой неделе времени нет',
    emptyText: 'Строки появятся для ваших открытых задач и задач, куда вы писали время на этой неделе',
  },
  today: {
    mine: 'Мои задачи на сегодня',
    mineHint: 'Просроченные задачи и те, что идут сегодня. Таймер — в шапке, все задачи — в «Задачах»',
    review: 'Ждут проверки',
    reviewHint:
      'Исполнители закончили задачи в ваших проектах: примите и подтвердите часы или верните с комментарием',
    atRisk: 'Под угрозой срыва',
    atRiskHint: 'Задачи, которые по плану и записанному времени не успевают к сроку',
    unassigned: 'Без исполнителя',
    unassignedHint:
      'Задачи ваших проектов, у которых нет исполнителя: «Подобрать» в панели задачи предложит кандидатов',
    due: '{project} · до {date}',
    allTasks: 'Все задачи',
    allReview: 'Все на проверке',
    allProjects: 'Все проекты',
  },
  timeDialog: {
    timerLead: 'Таймер идёт, пока вы его не остановите; идущий на другой задаче остановится и запишется',
    logLead: 'Часы за прошедший день — например, «1,5», «1:30» или «90м»',
    task: 'Задача',
    taskPlaceholder: 'Начните вводить название',
    noTasks: 'Открытых задач нет — время пишется на задачи, где вы исполнитель',
  },
  settingsPage: {
    title: 'Производство',
    hint: 'Правила времени для всей студии: предупреждение о забытом таймере и срок правки своих записей',
    timeTitle: 'Время',
    timeLead: 'Касается всех проектов и сотрудников',
    timerWarn: 'Предупредить о таймере через',
    timerWarnHint:
      'Таймер идёт дольше — владельцу придёт уведомление «Таймер идёт N часов». Сам таймер не останавливается',
    ownDays: 'Свои записи можно править',
    ownDaysHint:
      'Сколько дней назад сотрудник может вносить и править свои часы; раньше — только руководитель проекта. 0 — только сегодня',
    daysUnit: 'дн.',
  },
  workHints: {
    time: 'Время пишется на задачу таймером или вручную. Таймер в шапке виден на всех экранах; переход через полночь делится на два дня. Свои записи правятся, пока часы не подтверждены',
    confirm:
      'Руководитель принимает задачу и подтверждает часы каждого, кто писал время: подтверждённое × ставка копится сотруднику «К выплате». Поправили часы — укажите причину, её увидит сотрудник',
    timesheet:
      'Ячейка — ваши часы по задаче за день: введите «1,5», «1:30» или «90м», пусто — убрать. Подтверждённые дни закрыты, записи старше {days} дней правит руководитель',
    projectTime: 'Сколько времени записали участники проекта — таймером и вручную, подтверждённое и нет',
  },
} as const;

/** «К выплате» в карточке сотрудника (ключи `team.payable.*`). */
export const ruTeamPayable = {
  tab: 'К выплате',
  title: 'К выплате',
  hint: 'Подтверждённые часы × ставка на дату подтверждения, ещё не попавшие в подписанный акт о выплате. Акт подписан — строки уходят отсюда',
  example: 'Руководитель принял задачу и подтвердил 6 ч при ставке 1 500 ₽/ч — здесь появится 9 000 ₽',
  emptyTitle: 'Начислений нет',
  emptyText: 'Когда руководитель примет задачу и подтвердит часы, сумма появится здесь',
  confirmedOn: 'подтверждено {date}',
  compose: 'Составить акт о выплате',
  composeBlocked: 'Сначала договор и данные сотрудника — на вкладке «Документы»',
  pendingTitle: 'В акте на подписи',
  pendingHint: 'Эти часы уже стоят в акте о выплате, который ждёт подписи, — второй раз в акт не попадут',
  act: 'Акт о выплате',
  actNumber: 'Акт № {number}',
} as const;

/** Тексты ошибок `projects.*` части 5.2 (раздел 11 спецификации подпроекта 5). */
export const ruProjectsWorkErrors = {
  not_member: 'Время пишут участники проекта — попросите руководителя добавить вас',
  timer_running: 'Таймер уже идёт на задаче «{task}»',
  entry_future: 'Нельзя внести время на будущую дату',
  entry_locked: 'Часы уже подтверждены — попросите руководителя вернуть задачу',
  entry_too_old: 'Записи старше {days} дней правит руководитель',
  entry_minutes_invalid: 'Часы — от 1 минуты до 24 часов, например «1,5», «1:30» или «90м»',
  entry_note_invalid: 'Заметка — не длиннее 500 знаков',
  reason_required: 'Укажите, почему часы поправлены',
  reason_too_long: 'Причина — не длиннее 500 знаков',
  confirm_minutes_invalid: 'Подтверждённые часы — от 0 до 1000',
  return_comment_required: 'Напишите, что доработать, — комментарий уйдёт в обсуждение задачи',
  return_comment_too_long: 'Комментарий — не длиннее 2000 знаков',
  task_has_time: 'В задаче есть записи времени — её нельзя удалить',
  settings_timer_invalid: 'Предупреждение о таймере — от 1 до 24 часов',
  settings_days_invalid: 'Срок правки своих записей — от 0 до 365 дней',
  payout_forbidden: 'Начисления к выплате видит сам сотрудник и тот, кто видит ставки',
} as const;

/** «История» проекта: время и подтверждение. */
export const ruProjectsWorkAudit = {
  actions: {
    project: {
      time_added: 'Внесено время',
      time_changed: 'Изменено время',
      time_removed: 'Удалена запись времени',
      hours_confirmed: 'Часы подтверждены, задача принята',
      task_returned: 'Задача возвращена на доработку',
    },
    project_settings: {
      changed: 'Изменены настройки производства',
    },
  },
  entities: {
    project_settings: 'Настройки производства',
  },
  fields: {
    minutes: 'Часы',
    on: 'Дата',
    timerWarnMinutes: 'Предупреждение о таймере, минут',
    ownEntryDays: 'Правка своих записей, дней',
    deliverAct: 'Итоговый акт при сдаче',
  },
} as const;

/** Вкладки проекта 5.2 (в `projects.card`). */
export const ruProjectsWorkCard = {
  tabKanban: 'Канбан',
  tabTime: 'Время',
} as const;

/** Панель задачи 5.2 (в `projects.task`): описание и обсуждение. */
export const ruProjectsWorkTask = {
  noDescription: 'Описания нет',
  discussion: 'Обсуждение',
  discussionStart: 'Начать обсуждение',
  discussionEmptyTitle: 'Обсуждения пока нет',
  discussionEmptyText: 'Вопросы по задаче, файлы и правки — здесь; исполнитель получит уведомление',
} as const;

/** Команды ⌘K 5.2 (в `projects.palette`). */
export const ruProjectsWorkPalette = {
  startTimer: 'Запустить таймер на…',
  logTime: 'Внести время',
  startTimerOn: 'Запустить таймер: {title}',
  timerGroup: 'Таймер',
  timerKeywords: 'таймер время старт засечь',
  logKeywords: 'время часы табель записать',
} as const;
